import * as React from 'react';

import {
  formatDateToShortFormat,
  GRAY_STUDENT_HISTORY_BACKGROUND_IMG,
} from '../shared'
import { StudentLearningSequenceActivityInterface, } from '../interfaces'
import GradeColor, { GREEN, ORANGE, RED, } from '../../../modules/grade_color'
import { getTimeSpent, } from '../../../../helpers/studentReports'

interface IndividualStudentPracticeCardProps {
  activities?: StudentLearningSequenceActivityInterface[];
  relevantDiagnostic?: StudentLearningSequenceActivityInterface;
}

const IndividualStudentPracticeCard = ({ activities, relevantDiagnostic, }: IndividualStudentPracticeCardProps) => {
  const activityCount = activities?.length || 0
  const fullProficiencyInEverySkill = relevantDiagnostic?.skill_performance?.every(skill => skill.questions_total === skill.questions_correct)

  let completionText = fullProficiencyInEverySkill ? 'N/A' : 'None completed'
  let performanceCopy: JSX.Element|string = fullProficiencyInEverySkill ? 'N/A' : '—'
  let practiceCopy: JSX.Element|string = fullProficiencyInEverySkill ? 'No practice was recommended as full proficiency was demonstrated in all skills.' : '—'
  let greenActivityCount = 0
  let orangeActivityCount = 0
  let redActivityCount = 0

  if (activityCount) {
    const firstActivity = activities[0]
    completionText = formatDateToShortFormat(firstActivity.completed_at)

    if (activityCount > 1) {
      const lastActivity = activities[activityCount - 1]
      completionText += ` — ${formatDateToShortFormat(lastActivity.completed_at)}`
    }

    greenActivityCount = activities.filter(act => GradeColor(act.percentage) === GREEN)?.length || 0
    orangeActivityCount = activities.filter(act => GradeColor(act.percentage) === ORANGE)?.length || 0
    redActivityCount = activities.filter(act => GradeColor(act.percentage) === RED)?.length || 0

    performanceCopy = <React.Fragment>Scored green on {Math.round((greenActivityCount/activityCount) * 100)}% of activities</React.Fragment>

    practiceCopy = (
      <React.Fragment>
        <span>Activities completed: {activityCount}</span>
        <span>Time spent: {getTimeSpent(activities.reduce((sum, act) => sum + act.timespent, 0))}</span>
      </React.Fragment>
    )
  }

  return (
    <section className="student-learning-sequence-card practice-card">
      {GRAY_STUDENT_HISTORY_BACKGROUND_IMG}
      <div className="card-content">
        <h5>Practice</h5>
        <span className="completion">{completionText}</span>
        <div className="details">
          <div className="performance-and-practice">
            <h6>Performance</h6>
            {performanceCopy}
            <h6>Practice</h6>
            {practiceCopy}
          </div>
          {(activityCount || !relevantDiagnostic?.proficient) && (
            <div className="score-boxes">
              <div className="score-box green">{greenActivityCount}</div>
              <div className="score-box orange">{orangeActivityCount}</div>
              <div className="score-box red">{redActivityCount}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default IndividualStudentPracticeCard
